import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useVoiceQueueRouteSelected = (): IGlobalStore['voice_queue_route_selected'] => {
  return useSelector((store: IReducerStore) => store.global.voice_queue_route_selected);
};
